import React from 'react';

import { type DataTableValueVariant } from '../../DataTable.types';

import { EmptyState, Skeleton, StyledDataValue, Suffix, Value } from './DataValue.style';

export interface DataTableDataValueProps {
    value?: string | number;
    suffix?: string | number;
    variant?: DataTableValueVariant;
    subdued?: boolean;
}

const EMPTY_CELL = '—';

export function DataValue({ value, suffix, variant = 'neutral', subdued = false }: DataTableDataValueProps) {
    const valueMarkup = value ? <Value>{value}</Value> : null;
    const suffixMarkup = suffix ? <Suffix>{suffix}</Suffix> : null;

    const hasContent = Boolean(valueMarkup || suffixMarkup);

    return (
        <StyledDataValue $variant={variant} $subdued={subdued}>
            {valueMarkup}
            {suffixMarkup}
            {hasContent ? null : <EmptyState>{EMPTY_CELL}</EmptyState>}
        </StyledDataValue>
    );
}

export function SkeletonDataValue(_props: Partial<DataTableDataValueProps>) {
    return <Skeleton />;
}
